function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 273 \\u2013 219",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "llwfdakc8a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2506",
    style: {
      fill: "#262626"
    },
    d: "M0 0h15.003v18H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2339",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4751",
    transform: "translate(2.498 1)",
    style: {
      clipPath: "url(#llwfdakc8a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1015",
    d: "M6.146 0c.173.036.353.061.526.106a4.2 4.2 0 0 1 3.276 3.38 4.338 4.338 0 0 1-8.255 2.53 4.3 4.3 0 0 1 1.022-4.821A4.148 4.148 0 0 1 5.154.034.443.443 0 0 0 5.23 0z",
    transform: "translate(1.693)",
    style: {
      fill: "#262626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1016",
    d: "M7.5 13.166c-1.494 0-2.988.009-4.482 0a3.038 3.038 0 0 1-2.072-.774 2.628 2.628 0 0 1-.9-1.755 9.409 9.409 0 0 1 .589-4.363A3.7 3.7 0 0 1 2.3 4.26a3.31 3.31 0 0 1 1.636-.394 1.258 1.258 0 0 1 .538.184c.268.146.515.324.774.486a4.11 4.11 0 0 0 2.552.687 4.184 4.184 0 0 0 1.876-.63 5.225 5.225 0 0 0 .6-.392 1.7 1.7 0 0 1 1.548-.263 3.36 3.36 0 0 1 2.308 1.812 6.953 6.953 0 0 1 .76 2.538A17.594 17.594 0 0 1 15 10.265a2.841 2.841 0 0 1-2.36 2.824 4.541 4.541 0 0 1-.837.074c-1.435.007-2.871 0-4.306 0z",
    transform: "translate(0 4.832)",
    style: {
      fill: "#262626"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.cd30c5a9.svg";
export { ForwardRef as ReactComponent };